var _style, _path, _path2, _ellipse, _polyline, _polyline2, _polygon, _polygon2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluorescentLamp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "16.3px",
    viewBox: "0 0 16.3 16.3",
    style: {
      enableBackground: "new 0 0 16.3 16.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.4;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fluorescent Lamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,4.8H2.9C2,4.8,1.3,6.5,1.3,8.5s0.7,3.6,1.7,3.6h5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,12.1h5.2c0.9,0,1.7-1.6,1.7-3.6s-0.7-3.6-1.7-3.6H8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 8.2,
    cy: 6.5,
    rx: 0.3,
    ry: 0.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "16.3,10 13,10 12.4,8.6 13,7.1 16.3,7.1 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "0,9.9 3,9.9 3.6,8.4 3,7 0,7 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3.6,9.9 3.6,6.8 5.5,8.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "12.4,10 12.4,7.1 10.8,8.6 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3.6,
    y1: 6,
    x2: 3.6,
    y2: 10.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 12.4,
    y1: 6.1,
    x2: 12.4,
    y2: 10.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluorescentLamp);
export default __webpack_public_path__ + "static/media/FluorescentLamp.da7eeb43cee220fd36b0cc0e4656ffde.svg";
export { ForwardRef as ReactComponent };